module.exports = __webpack_public_path__ + "static/media/appstore-4e1.db97d5d0.png";